import * as React from "react";

export const HintPopupContext = React.createContext(undefined as any);

export interface IHintPopupProviderProps {
  children : React.ReactNode;
}

export const HintPopupContextProvider = (props : IHintPopupProviderProps) => {
    const [currentHintPopup, setCurrentHintPopup] =  React.useState("");

    return (
        <HintPopupContext.Provider value={[currentHintPopup, setCurrentHintPopup]}>
            {props.children}
        </HintPopupContext.Provider>
    );
};
